// src/pages/Blogs/BlogsList.jsx

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBlogs } from "./BlogService";
import MainLayout from "../../layouts/MainLayout";
import { DataGrid } from "@mui/x-data-grid";
import { TextField, InputAdornment } from "@mui/material";
import "./Blogs.css";

export default function BlogsList() {
  const [blogs, setBlogs]       = useState([]);
  const [page, setPage]         = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal]       = useState(0);
  const [search, setSearch]     = useState("");
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      const res = await getBlogs(page + 1, pageSize, search);
      setBlogs(res.blogs || []);
      setTotal(res.total || 0);
      setLoading(false);
    };
    fetchBlogs();
  }, [page, pageSize, search]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      headerClassName: "datagrid-header",
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      minWidth: 220,
      headerClassName: "datagrid-header",
      renderCell: (params) => (
        <span style={{ fontWeight: 500, color: "#0f172a" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "category",
      headerName: "Category",
      width: 140,
      headerClassName: "datagrid-header",
      renderCell: (params) => (
        <span style={{
          background: "#e0f2fe",
          color: "#0369a1",
          fontSize: "0.75rem",
          fontWeight: 600,
          padding: "3px 10px",
          borderRadius: 999,
        }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "doctorName",
      headerName: "Author",
      width: 180,
      headerClassName: "datagrid-header",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      sortable: false,
      headerClassName: "datagrid-header",
      renderCell: (params) => (
        <div style={{ display: "flex", gap: 8, alignItems: "center", height: "100%" }}>
          <Link to={`/blogs/${params.row.id}`} style={{ textDecoration: "none" }}>
            <button className="grid-btn-view">View</button>
          </Link>
          <Link to={`/blogs/edit/${params.row.id}`} style={{ textDecoration: "none" }}>
            <button className="grid-btn-edit">Edit</button>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <MainLayout>
      <div className="blogs-page">

        {/* Header */}
        <div className="blogs-page-header">
          <h2 className="blogs-page-title">
            Blogs <span>Management</span>
          </h2>
          <Link to="/blogs/create" className="btn-create-blog">
            ＋ Create Blog
          </Link>
        </div>

        {/* Search */}
        <div className="blogs-search-wrap">
          <TextField
            placeholder="Search by title, author, category…"
            variant="outlined"
            size="small"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <span style={{ fontSize: "1rem" }}>🔍</span>
                </InputAdornment>
              ),
              style: { borderRadius: 8, background: "#fff", fontSize: "0.875rem" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "#94a3b8" },
                "&.Mui-focused fieldset": { borderColor: "#0ea5e9" },
              },
            }}
          />
        </div>

        {/* DataGrid */}
        <div className="blogs-grid-wrap">
          <DataGrid
            rows={blogs}
            columns={columns}
            paginationMode="server"
            rowCount={total}
            loading={loading}
            pageSizeOptions={[5, 10, 25]}
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={(model) => {
              setPage(model.page);
              setPageSize(model.pageSize);
            }}
            disableRowSelectionOnClick
            autoHeight
            sx={{
              border: "none",
              fontFamily: "'Inter', sans-serif",
              fontSize: "0.875rem",
              "& .MuiDataGrid-columnHeaders": {
                background: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
                fontSize: "0.8rem",
                fontWeight: 700,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              },
              "& .MuiDataGrid-row:hover": {
                background: "#f0f9ff",
              },
              "& .MuiDataGrid-cell": {
                borderColor: "#f1f5f9",
                color: "#334155",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #e2e8f0",
                background: "#f8fafc",
              },
              "& .MuiTablePagination-root": {
                fontSize: "0.8rem",
                color: "#64748b",
              },
            }}
          />
        </div>

      </div>
    </MainLayout>
  );
}